<template>
  <div class="unifyLoginBox">
    <header>
      <h2>漯河市公共资源交易统一身份认证平台</h2>
      <div class="userBox">
        <p>
          <img src="../../assets/img/lh-unify/user.png" alt="">
          <span>{{ displayName }}</span>
        </p>
          <p v-if="isShowUseCenter">
              <span> | </span>
              <span  class="logout" style="margin-left: 10px; margin-right: 10px" @click="$router.push({name:'useCenter'})"> 用户中心 </span>
              <span> | </span>
          </p>
        <p class="logout" @click="logoutHandle">
          <img src="../../assets/img/lh-unify/logout.png" alt="">
          <span>退出</span>
        </p>
      </div>
    </header>
    <main>
      <div v-for="(item,ind) in systemList" :key="ind" class="systemBox">
        <p class="systemBox__title">
          <img src="../../assets/img/lh-unify/nav.png" alt="">
          <span>{{ item.systemSingleName }}</span>
        </p>
        <ul class="systemBox__down">
          <li @click="skipSystem(zhi.basePath,zhi.gatewayInfo)" :key="idx" v-for="(zhi,idx) in item.systemSingleList">
            <div class="singleSystem">
              <div class="imgBox" :style="{ background:item.colorList[idx] }"><img v-if="zhi.appLogo" :src="'/api' + zhi.appLogo" alt=""></div>
              <div class="systemNameBox">
                <h6>{{ zhi.appName }}</h6>
                <p><span>进入</span><i></i></p>
              </div>
            </div>
            <div class="blueShadow"></div>
          </li>
        </ul>
      </div>
    </main>
  </div>
</template>

<script>
import {logout} from '@/utils/login'
import axios from 'axios'
let ssoHttpCreateOps= {
  timeout: 1000 * 30,
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Content-Type': 'application/json; charset=utf-8'
  }
}
const ssoHttp = axios.create(ssoHttpCreateOps)
export default {
  name: "unifyLogin",
  data(){
    return{
      systemList:[],
      systemNameList:['其他系统','综合系统','交易系统','服务系统'],
      colorList: {
        0:['#15AD31','#FFB200','#128AFF','#1ECBA9'],
        1:['#FA8C15','#5F76F3'],
        2:['#128AFF','#FA8C15','#5F76F3','#15AD31'],
        3:['#FFB200','#1ECBA9','#128AFF'],
      }
    }
  },
  created(){
    this.getSystemList()
    this.getToken()
  },
  computed:{
    displayName: {
      get() {
        var username = this.$store.state.user.displayName
        if (username === '') {
          username = '游客'
        }
        return username
      }
    },
    token: {
      get() {
        return this.$store.state.user.token
      },
    },
      isShowUseCenter: {
          get() {
              return window.SITE_CONFIG.regionCode === '41110'
          }
      }
  },
  methods:{
    getSystemList(){
      this.$http.post(`/auth/application/groupAppList`).then(({data}) => {
        Object.keys(data.data).forEach((key) => {
          this.systemList.push({
            systemSingleName: this.systemNameList[key],
            systemSingleList: data.data[key],
            colorList:this.colorList[key]
          })
        })
        let single = this.systemList.splice(0,1)
        this.systemList.push(single[0])
      })
    },
    skipSystem(basePath,gatewayInfo){
      this.getToken((token) => {
        // console.log(gatewayInfo ? `${gatewayInfo}?token=${token}` : `${basePath}/oauth/tokenLogin?token=${token}`)
        window.open(gatewayInfo ? `${gatewayInfo}?token=${token}` : `${basePath}/oauth/tokenLogin?token=${token}`)
      })
    },
    //获取token
    getToken(callback){
      this.$http.post(`/oauth/refleshToken`).then(res => {
        callback && callback(res.data.authCode ? res.data.authCode : '')
      })
    },
    // 退出
    logoutHandle() {
      this.$confirm(`确定进行[退出]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        logout()
      })
    }
  }
}
</script>

<style scoped lang="scss">
    *{
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }
  .unifyLoginBox{
    font-family: "Microsoft YaHei" ;
    width: 100%;
    height: 100%;
    background: #F5F6F7;
    header{
      background: white;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 50px;
      padding: 0 20px;
      box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.1);
      h2{
        font-size: 20px;
        color: rgba(0, 0, 0, 0.85);
      }
      .userBox{
        display: flex;
        align-items: center;
        p{
          padding-right: 10px;
          opacity: .65;
          img{
            margin-right: 5px;
          }
          span{
            position: relative;
            top: 2px;
          }
        }
        .logout:hover{
          cursor: pointer;
          background: #EEEEEE;
          border-radius: 2px;
        }
      }
    }
    main{
      padding: 20px;
      .systemBox{
        &__title{
          span{
            font-size: 20px;
            margin-left: 5px;
            position: relative;
            top: 4px;
          }
        }
        &__down{
          margin-top: 20px;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          li{
            flex-basis: 18%;
            position: relative;
            background: #FFFFFF;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
            //display: flex;
            height: 92px;
            //align-items: center;
            margin-bottom: 20px;
            margin-right: 32px;
            .singleSystem{
              background: #FFFFFF;
              width: 100%;
              height: 100%;
              padding: 10px 20px;
              display: flex;
              align-items: center;
              position: absolute;
              z-index: 100;
              .imgBox{
                width: 52px;
                height: 52px;
                background: #128AFF;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;
                margin-right: 20px;
                img{
                  width: 32px;
                }
              }
              .systemNameBox{
                flex: 1;
                padding: 5px 0;
                height: 72px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                h6{
                  color: rgba(0, 0, 0, 0.85);
                  //font-family: MicrosoftYaHei;
                  font-size: 16px;
                  font-weight: normal;
                }
                p{
                  font-size: 14px;
                  span{
                    opacity: .45;
                    margin-right: 5px;
                  }
                  i{
                    display: inline-block;
                    width: 14px;
                    height: 14px;
                    background: url("../../assets/img/lh-unify/swap_right.png") no-repeat;
                    position: relative;
                    top: 2px;
                  }
                }
              }
            }
          }
          li:nth-child(5n){
            margin-right: 0;
          }
          li:hover{
            cursor: pointer;
            position: relative;
            bottom: 3px;
            .blueShadow{
              bottom: 0;
              left: calc(50% - 30%);
              position: absolute;
              width: 60%;
              height: 1px;
              box-shadow: 0 0 24px 5px #DAE6ED;
              border-radius: 50%;
            }
            .systemNameBox{
              p{
                color: #1890FF;
                opacity: 1;
                span{
                  opacity: 1;
                }
                i{
                  background: url("../../assets/img/lh-unify/swap_right_show.png") no-repeat;
                }
              }
            }
          }
        }
      }
    }
  }
</style>